import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ColumnRendererComponentV3 } from '@gea/digital-ui-lib';
import { TranslatePipe, TranslationService } from '@spartacus/core';
import { of } from 'rxjs';
import { DataSheet } from 'src/app/custom/models/classes/datasheet.model';
import { ProductDataSheetService } from 'src/app/custom/services/product/product-datasheet.service';

@Component({
  selector: 'custom-attachment-download-renderer',
  template: '<span>{{category$ | async}}</span>',
  imports: [CommonModule],
})
export class CustomAttachmentCategoryRendererComponent implements ColumnRendererComponentV3<DataSheet> {
  translationService = inject(TranslationService);

  rowData?: DataSheet;

  get category$() {
    if (this.rowData && this.rowData.category) {
      return this.translationService.translate(
        `TabPanelContainer.attachmentTable.categories.${this.rowData.category}`,
      );
    }
    return of('-');
  }
}
